import React from "react";
import "./Privacy.css";
import { HashLink } from 'react-router-hash-link';
import logo from '../assets/images/ilt_logo.png';
import Header from "../components/Header";

const HEADER_OFFSET = 100; // px — change to your header height


const Privacy = () => {
  return (
    <div>
 <Header />
    <div className="privacy-page">
         
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: October 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          This website is a personal portfolio created to showcase professional
          experience and projects. This Privacy Policy explains how this site
          collects, uses, and protects visitor information.
        </p>
      </section>

      <section>
        <h2>2. Data Collection</h2>
        <p>
          This website does not directly collect personal information such as
          names or email addresses. However, certain analytics and hosting tools
          may automatically collect limited data such as:
        </p>
        <ul>
          <li>IP address and approximate geolocation</li>
          <li>Browser type and device information</li>
          <li>Pages visited and duration of visit</li>
        </ul>
      </section>

      <section>
        <h2>3. Use of Data</h2>
        <p>
          The data collected is used only to monitor website performance,
          improve user experience, and understand general visitor engagement.
        </p>
      </section>

      <section>
        <h2>4. Cookies and Tracking</h2>
        <p>
          This website uses Google Analytics, which relies on cookies to
          analyze visitor behavior. Cookies are small text files stored on your
          device. You can disable cookies in your browser settings if you prefer
          not to share this information.
        </p>
        <p>
          Google Analytics data is processed in accordance with Google’s{" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
      </section>

      <section>
        <h2>5. Data Sharing</h2>
        <p>
          No personal data is sold, rented, or shared with third parties.
          Analytics data is processed by Google in accordance with their data
          protection practices.
        </p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>
          Analytics data is retained for as long as necessary to analyze website
          performance and trends, typically within the retention period defined
          by Google Analytics.
        </p>
      </section>

      <section>
        <h2>7. Your Rights</h2>
        <p>
          You can opt out of Google Analytics tracking by using the{" "}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Analytics Opt-out Browser Add-on
          </a>
          .
        </p>
      </section>

      <section>
        <h2>8. External Links</h2>
        <p>
          This website may include links to external sites. Those sites operate
          independently and have their own privacy policies, which are not
          controlled by this site.
        </p>
      </section>

      <section>
        <h2>9. Changes to This Policy</h2>
        <p>
          This Privacy Policy may be updated occasionally to reflect legal or
          technical changes. The updated version will be posted on this page.
        </p>
      </section>

      <section>
        <h2>10. Contact</h2>
        <p>
          If you have questions about this Privacy Policy or how your data is
          handled, you can reach out through LinkedIn or other professional
          channels provided on the site.
        </p>
      </section>

      <div className="back-link">
        <a href="/">← Back to Home</a>
      </div>
    </div>
    </div>
  );
};

export default Privacy;
